import { useEffect, useRef } from 'react';

function Cursor() {
  const cursorRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;

    const moveCursor = (e) => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    };

    const expandCursor = () => {
      cursor.style.width = '50px';
      cursor.style.height = '50px';
      cursor.style.backgroundColor = 'rgba(0, 255, 204, 0.1)';
    };

    const shrinkCursor = () => {
      cursor.style.width = '20px';
      cursor.style.height = '20px';
      cursor.style.backgroundColor = 'transparent';
    };

    document.addEventListener('mousemove', moveCursor);

    const attachHoverListeners = () => {
      document.querySelectorAll('a, button, input, textarea, .project-card').forEach(el => {
        el.addEventListener('mouseenter', expandCursor);
        el.addEventListener('mouseleave', shrinkCursor);
      });
    };

    attachHoverListeners();

    const observer = new MutationObserver(attachHoverListeners);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      document.removeEventListener('mousemove', moveCursor);
      observer.disconnect();
    };
  }, []);

  return <div ref={cursorRef} className="cursor" />;
}

export default Cursor;
